import React, { useCallback } from 'react';
import { useLocalStorage } from 'utils/useLocalStorage';
import cx from 'classnames';

import FleetMenu from 'modules/fleet/menu';

const FleetSidebar = ({ className, section, parentUrl }) => {
  const [collapsed, setCollapsed] = useLocalStorage('fleet/sidebarCollapsed', false);

  const handleCollapse = useCallback(() => {
    setCollapsed((collapsed) => !collapsed);
  }, [setCollapsed]);

  return (
    <div
      className={cx(className, {
        collapsed,
      })}
      data-testid="fleetSidebar"
    >
      <FleetMenu
        rootRoute={parentUrl}
        collapsed={collapsed}
        onCollapseClick={handleCollapse}
        section={section}
      />
    </div>
  );
};

export default FleetSidebar;
